import { render } from "./cnt-table_milestones.vue?vue&type=template&id=28c4349e&scoped=true"
const script = {}

import "./cnt-table_milestones.vue?vue&type=style&index=0&id=28c4349e&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28c4349e"]])

export default __exports__